module.exports = {
    bindings: {
        opinion: '<'
    },
    templateUrl: 'texts/components/wco-classification-opinion.html'
};